<div class="form-container service-form ms-large-y" #formContainer>
  <ng-container *ngIf="!loggedOutMissingPointsFormSuccess">
    <!-- Initial form state -->
    <form
      *ngIf="formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR"
      [formGroup]="reactiveForm"
      (ngSubmit)="onSubmit()"
      [finFormErrorFocus]="reactiveForm"
    >
      <div *ngIf="formStatus === FormStatus.ERROR">
        <fin-form-error [errorText]="errorLocalizationKey | finLocalization"></fin-form-error>
      </div>
      <p class="font-body-1 mr-medium-b nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization }}
      </p>
      <div class="flex flex--row flex--wrap form-subgroup">
        <fin-select-input
          [parentForm]="reactiveForm"
          [controlName]="LoggedInMissingPointsFormField.AIRLINE"
          [options]="airlines"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.airline'"
        >
        </fin-select-input>
        <fcom-text-input
          data-testid="logged-in-missing-points-ticket-number"
          *ngIf="!reactiveForm.get(LoggedInMissingPointsFormField.NO_TICKET_NUMBER).value"
          [parentForm]="reactiveForm"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.ticketNumber.placeHolder'"
          [controlName]="LoggedInMissingPointsFormField.TICKET_NUMBER"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ticketNumber'"
          [useCustomTooltipAction]="true"
          (tooltipClicked)="showHelp($event)"
        ></fcom-text-input>
      </div>
      <div class="flex flex--row flex--wrap form-subgroup">
        <fin-form-input-checkbox
          [parentForm]="reactiveForm"
          [controlName]="LoggedInMissingPointsFormField.NO_TICKET_NUMBER"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.noTicketNumber'"
        >
        </fin-form-input-checkbox>
      </div>
      <ng-container *ngIf="!reactiveForm.get(LoggedInMissingPointsFormField.NO_TICKET_NUMBER).value">
        <div
          class="flex flex--row flex--wrap form-subgroup ms-xlarge-t"
          *ngIf="reactiveForm.get(LoggedInMissingPointsFormField.AIRLINE).value !== Airline.FINNAIR"
        >
          <fin-select-input
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.BOOKING_CLASS"
            [options]="bookingClasses"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bookingClass'"
          >
          </fin-select-input>
          <fin-locations-autocomplete
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.DEPARTURE_AIRPORT"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.origin'"
            [inputType]="'text'"
            [options$]="departureLocations$"
            [loading$]="departureLoading$"
            [theme]="AutocompleteTheme.WEB_2"
          ></fin-locations-autocomplete>
          <fin-locations-autocomplete
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.ARRIVAL_AIRPORT"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.destination'"
            [inputType]="'text'"
            [options$]="destinationLocations$"
            [loading$]="destinationLoading$"
            [theme]="AutocompleteTheme.WEB_2"
          >
          </fin-locations-autocomplete>
          <fin-datepicker
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.FLIGHT_DATE"
            [placeHolder]="'SERVICE_FORMS.serviceForms.fields.missingPointsFlightDate.placeholder'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.missingPointsFlightDate'"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [theme]="DatepickerTheme.WEB_2"
          ></fin-datepicker>
          <fcom-text-input
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.FLIGHT_NUMBER"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.flightNumberMissingPoints'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.fields.flightNumberMissingPoints.placeholder'"
          >
          </fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get(LoggedInMissingPointsFormField.SEQUENCE_NUMBER).enabled"
            [parentForm]="reactiveForm"
            [controlName]="LoggedInMissingPointsFormField.SEQUENCE_NUMBER"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.sequenceNumber'"
          ></fcom-text-input>
        </div>
        <div class="ps-small-t align-right">
          <fcom-button
            [type]="ButtonType.SUBMIT"
            [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
          ></fcom-button>
        </div>
      </ng-container>
    </form>
    <!-- While sending -->
    <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
      <fin-loader [type]="LoaderType.INLINE"></fin-loader>
    </div>
    <!-- Success view -->
    <div *ngIf="formStatus === FormStatus.COMPLETE">
      <h2>{{ 'SERVICE_FORMS.serviceForms.success.title' | finLocalization }}</h2>
    </div>
  </ng-container>
  <fin-logged-out-missing-points-form
    *ngIf="reactiveForm.get(LoggedInMissingPointsFormField.NO_TICKET_NUMBER).value"
    [profile]="profile$ | async"
    [selectedAirlineCode]="reactiveForm.get(LoggedInMissingPointsFormField.AIRLINE).value"
    (formComplete)="onLoggedOutMissingPointsFormComplete($event)"
  ></fin-logged-out-missing-points-form>
</div>

<fcom-modal
  [title]="'SERVICE_FORMS.serviceForms.missingPoints.ticketNumberHelpTitle' | finLocalization"
  [(open)]="ticketNumberHelpModalOpen"
  [buttons]="ModalButtons.CLOSE"
>
  <div class="pr-medium">
    <cms-unstyled-fragment
      *ngIf="'fragments.missingPointsTicketNumberHelpModal.url' | finLocalization"
      class="block font-body-1 unstyled-fragment-line-height pr-medium-b help-modal"
      [contentUrl$]="'fragments.missingPointsTicketNumberHelpModal.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
</fcom-modal>
